import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { Marker } from 'react-map-gl';
import DefaultPin from '../SolvPatternLibrary/InteractiveMap/DefaultPin';
import { isEmptyObject } from '../../core/util/object';

const CenteredMarker = styled(Marker).withConfig({ componentId: 'sc-lvccpe-0' })`
  transform: translate(-50%, -50%);
  z-index: ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'highlight' does not exist on type 'Marke... Remove this comment to see the full error message
    highlight,
  }) => (highlight ? Number.MAX_SAFE_INTEGER : 0)};
`;

type Props = {
  latitude: number | string;
  longitude: number | string;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  pin?: func;
};

class MarkerContainer extends PureComponent<Props> {
  render() {
    const { latitude, longitude, pin } = this.props;
    const PinClass = !isEmptyObject(pin) ? pin : DefaultPin;
    return (
      // @ts-expect-error ts-migrate(2345) FIXME: Type 'number' is not assignable to type 'string'.
      <CenteredMarker latitude={parseFloat(latitude)} longitude={parseFloat(longitude)}>
        <PinClass />
      </CenteredMarker>
    );
  }
}

export default MarkerContainer;
